module.exports = __webpack_public_path__ + "static/widgets_4-39d0fcacb6984e46dc0ea3a6d8dc65fb.png";